import { Copy } from '@emotion-icons/fa-solid/Copy'
import { Check } from '@emotion-icons/fa-solid/Check'
import styled from '@emotion/styled'
import { IconButton } from '@mui/material'
import { FC, useState } from 'react'
import { Colors } from 'src/components/theme'
import { copyTo } from 'src/utils/clipboard'

export const IconActionButton = styled(IconButton)<{ ghost: 1 | 0; active?: 1 | 0 }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: ${(props) => (props.ghost ? 'none' : `1px solid ${Colors.neutral50}`)};
  border-radius: 6px;
  background-color: ${(props) => (props.active ? Colors.blueDark : 'white')};
  color: ${(props) => (props.active ? 'white' : Colors.neutral400)};
  cursor: pointer;
  padding: 2px;

  svg {
    fill: ${(props) => (props.active ? 'white' : Colors.neutral400)};
    color: ${(props) => (props.active ? 'white' : Colors.neutral400)};
  }

  :hover {
    background-color: ${(props) => (props.active ? Colors.blueDark : Colors.neutral50)};
  }
  &.tada {
    animation: tada 1s;
  }
  @keyframes tada {
    0% {
      transform: scale(1);
    }
    10%,
    20% {
      transform: scale(0.9) rotate(-3deg);
    }
    30%,
    50%,
    70%,
    90% {
      transform: scale(1.1) rotate(3deg);
    }
    40%,
    60%,
    80% {
      transform: scale(1.1) rotate(-3deg);
    }
    100% {
      transform: scale(1) rotate(0);
    }
  }
`
type CopyButtonProps = {
  textToCopy: string
  ghost?: boolean
  color?: string
}
export const CopyButton: FC<CopyButtonProps> = ({ textToCopy, ghost }) => {
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    try {
      void copyTo(textToCopy) // Copy to clipboard
      setCopied(true) // Show tick icon
      setTimeout(() => setCopied(false), 2000) // Revert back to copy icon after 2 seconds
    } catch (err) {
      console.error('Failed to copy: ', err)
    }
  }

  return (
    <IconActionButton ghost={ghost ? 1 : 0} className={`copy-button ${copied ? 'tada' : ''}`} onClick={handleCopy}>
      {copied ? <Check size={12} /> : <Copy size={12} />}
    </IconActionButton>
  )
}
